/* eslint-disable */

export const createStrategyBotConstant = {
    FETCH_CREATE_STRATEGY_BOT_REQUEST: 'FETCH_CREATE_STRATEGY_BOT_REQUEST',
    FETCH_CREATE_STRATEGY_BOT_SUCCESS: 'FETCH_CREATE_STRATEGY_BOT_SUCCESS',
    FETCH_CREATE_STRATEGY_BOT_FAILURE: 'FETCH_CREATE_STRATEGY_BOT_FAILURE',
};
